module.exports = __webpack_public_path__ + "img/4-1.97a85e31.png";